export type Employee = {
  _id: string;
  createdBy: string;
  updatedBy: string;
  isDeleted: boolean;
  tenantId: string;
  vendorId: string;
  userId: string;
  status: string;
  permissions: EmployeeRoleEnum[];
  createdAt: string;
  updatedAt: string;
  boardCount: number;
  __v: number;
  userInfo: UserInfo;
  supportRoles?: string[];
};

export enum EmployeeRoleEnum {
  SUPER_ADMIN = 'SUPER_ADMIN',
  PORTAL_CREATOR = 'PORTAL_CREATOR',
  BACK_OFFICE_ADMIN = 'BACK_OFFICE_ADMIN',
}

type UserInfo = {
  Name: string;
  Email: string;
  DisplayPic: string;
  Handle: string;
};
